import { AnyAction, Reducer } from 'redux';

export const STORE_DESIGNPREFERENCES_DATA = 'store/designprefernces-codes-dropdown';
export const STORE_CUST_DESIGNPREFERENCE_DATA = 'customer/designpreference-data';
export const STORE_CUST_DESIGNPREFERENCE_DATA_INITIAL = 'initial-value-from-api-customer/designpreference-data';
export const STORE_MATERIALFILES_DATA = 'initial-value-from-api-customer/materialfiles-data';

export interface DesignPreferencesData {
    rowno: string;
    listcode: string;
    listtype: string;
    valuecode: string;
    valuedesc: string;
    is_default: string;
    parentcode: string;
    listdata: {
        listtype: string;
        dropvalue: { valuecode: string; valuedesc: string; isdefault: string }[];
    }[];
}

export interface CustDPrefData {
    rowno: string;
    customer: string;
    customersbu: string;
    listcode: string;
    listtype: string;
    valuecode: string;
    valuedesc: string;
    fvaluedesc: string;
    recordid: string;
    customerpreferencedtlid: string;
    other: string;
    othervalue: string;
    fothervalue: string;
}

export interface EditDesignPreferenceState {
    designPreferencesData: Array<DesignPreferencesData>;
    custDPrefData: Array<CustDPrefData>;
    custDPrefDataInitial: Array<CustDPrefData>;
}

const initialState: EditDesignPreferenceState = {
    designPreferencesData: [],
    custDPrefData: [],
    custDPrefDataInitial: []
};

const reducer: Reducer<EditDesignPreferenceState> = (state: EditDesignPreferenceState = initialState, action: AnyAction): EditDesignPreferenceState => {
    switch (action.type) {
        case STORE_DESIGNPREFERENCES_DATA:
            return {
                ...state,
                designPreferencesData: action.designPreferencesData
            };

        case STORE_CUST_DESIGNPREFERENCE_DATA:
            return {
                ...state,
                custDPrefData: action.custDPrefData
            };
        case STORE_CUST_DESIGNPREFERENCE_DATA_INITIAL:
            return {
                ...state,
                custDPrefDataInitial: action.custDPrefDataInitial
            };
        default:
            return state;
    }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/editDesignPreference.tsx